module.exports = __webpack_public_path__ + "static/media/instagram-01.d9ad6de7.jpg";